import axios from "axios";
import store from "../store";

class Products {

    async save_admin(data) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
            axios
                .post(
                    process.env.VUE_APP_SAAS_BACK + "/products",
                    data,
                    {
                        headers: { Authorization: "Bearer " + jwt },
                    }
                )
                .then(function (response) {
                    var data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error.response);
                });
        }); 
    }

    async load_admin() {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
            axios
                .get(
                    process.env.VUE_APP_SAAS_BACK + "/products/admin",
                    {
                        headers: { Authorization: "Bearer " + jwt },
                    }
                )
                .then(function (response) {
                    var data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error.response);
                });
        }); 
    }

    async load_css() {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
            axios
                .get(
                    process.env.VUE_APP_SAAS_BACK + "/products/css",
                    {
                        headers: { Authorization: "Bearer " + jwt },
                    }
                )
                .then(function (response) {
                    var data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error.response);
                });
        }); 
    }    

    async load_menu() {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
            axios
                .get(
                    process.env.VUE_APP_SAAS_BACK + "/products/menu",
                    {
                        headers: { Authorization: "Bearer " + jwt },
                    }
                )
                .then(function (response) {
                    var data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error.response);
                });
        }); 
    }

    async load_main_page() {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
            axios
                .get(
                    process.env.VUE_APP_SAAS_BACK + "/products/main_page",
                    {
                        headers: { Authorization: "Bearer " + jwt },
                    }
                )
                .then(function (response) {
                    var data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error.response);
                });
        }); 
    }

    async load_product(slug) {
        let jwt = store.state.jwt;

        return new Promise(function (resolve, reject) {
            axios
                .get(
                    process.env.VUE_APP_SAAS_BACK + "/products/product/" + slug,
                    {
                        headers: { Authorization: "Bearer " + jwt },
                    }
                )
                .then(function (response) {
                    var data = response.data;
                    resolve(data);
                })
                .catch(function (error) {
                    reject(error.response);
                });
        }); 
    }
}

export default new Products();